import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * サンプル発注書・撮影指示書PDF出力項目取得
 */
@Injectable()
export class GetSampleOrderingOutputService extends PlessJsonResponderSub<any> {

  private imageGroupNoList: string[];

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSampleOrderingOutputService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        ImageGroupNoList: {
          combination: this.imageGroupNoList.length === 0 ? [{
            parameter: {
              ImageGroupNO: null
            }
          }] : this.imageGroupNoList.map(_ => {
            return {
              parameter: {
                ImageGroupNO: _
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {Function} [successFunc=null]
   * @memberof GetSampleOrderingOutputService
   */
  execute(imageGroupNoList: string[], successFunc: Function): void {
    this.successFunc = successFunc;
    this.imageGroupNoList = imageGroupNoList;
    this.send('KYMW17GetSampleOrderingOutput', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSampleOrderingOutputService
   */
  success(data: any): void {
    if (this.successFunc !== null && data !== null) {
      this.successFunc(data.FileUrl);
    }
  }
}
